import React from 'react';

import { useComposablePage } from '../../../../../../helpers/composable';
import withBrandedComposablePage from '../../../../../../hocs/withBrandedComposablePage';
import ComposablePageLayout from '../../../../../../layouts/ComposablePageLayout';
import CatalogItemPageQuery from './CatalogItemPage.gql';
import pageData from './CatalogItemPage.json';
import notFoundPageData from './CatalogItemPageNotFound.json';

const CatalogIndexPage = () => {
  const { render } = useComposablePage();
  const content = render(pageData, notFoundPageData);

  return <ComposablePageLayout>{content}</ComposablePageLayout>;
};

export default withBrandedComposablePage({
  query: CatalogItemPageQuery,
  isFound: (data) => data.brand.catalog && data.brand.catalog.item,
})(CatalogIndexPage);
